export default __webpack_public_path__ + "static/cross-lines-ff9552d6a6718b62c9ac817fcc433db7.png";